export function getSpaceThreadActionInput({ thread, displayTitle, onDelete, deleteConfirmation, }) {
    return {
        title: displayTitle,
        contextUUID: thread.context_uuid ?? undefined,
        onDelete,
        showRename: Boolean(thread.context_uuid),
        deleteConfirmation,
        threadRenameAnalytics: {
            surface: 'spaceSidebar',
            threadType: thread.mode === 'asi' ? 'computer' : 'search',
        },
    };
}
//# sourceMappingURL=spaceThreadActionInput.js.map